import React, { useLayoutEffect } from 'react';
import { Switch, useLocation, useHistory } from 'react-router-dom';
import { MessageDialog } from '@Local/Components/';
import { NotFoundPage } from '@Local/Error/';
import { PrivateRoute } from '@Components/';
import { MEMBER_ROOT_ROUTER, EMPLOYEE_ROOT_ROUTER } from '@Router/routerPath';
import LandingPage from '@Local/Landing/';
import PrivacyPolicy from "@Local/PrivacyPolicy/PrivacyPolicy";
import { localUser } from "@Util/utils";
import { MEMBER_SITE_LOGON_TYPE } from "@Constants/";

const Home = () => {
    const { replace: routeReplace } = useHistory();
    const { pathname: rootPath = '' } = useLocation();
    
    const { logonType } = localUser.get() || {};
    
    useLayoutEffect(
        () => {
            const splitPath = rootPath.split('/');
            if (splitPath.length === 2 && splitPath.filter((x) => x).length === 0) {
                if (logonType === MEMBER_SITE_LOGON_TYPE.MEMBER) routeReplace(MEMBER_ROOT_ROUTER);
                else if (logonType === MEMBER_SITE_LOGON_TYPE.EMPLOYEE) routeReplace(EMPLOYEE_ROOT_ROUTER);
            } else if (splitPath.includes('index') || splitPath.includes('index.html')) {
                routeReplace('/');
            }
        },
        // eslint-disable-next-line
        [rootPath, routeReplace],
    );

    return (
        <React.Fragment>
            <Switch>
                <PrivateRoute static path={MEMBER_ROOT_ROUTER} as={LandingPage} />
                <PrivateRoute static path={EMPLOYEE_ROOT_ROUTER} as={LandingPage} />
                <PrivateRoute path="*" as={NotFoundPage} />
            </Switch>
            <PrivacyPolicy />
            <MessageDialog />
        </React.Fragment>
    );
};

export default Home;
